class ProductScrollToTop extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.js-scroll-to-top');

    if (this.link) {
      this.link.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    event.preventDefault();
    
    const appointoBtn = document.getElementById('appointo-btn') || document.querySelector('.appointo-btn');
    if (appointoBtn) {
      appointoBtn.click();
    } else {
      // Fallback: wait for the element to appear in the DOM
      const observer = new MutationObserver((mutations, obs) => {
        const btn = document.getElementById('appointo-btn') || document.querySelector('.appointo-btn');
        if (btn) {
          btn.click();
          obs.disconnect();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Stop observing after 10 seconds to avoid memory leaks
      setTimeout(() => observer.disconnect(), 10000);
    }
  }
}

customElements.define('product-scroll-to-top', ProductScrollToTop);
